import { FileWithPath } from 'react-dropzone';

export const checkFormatValidation = (
  files: FileWithPath[],
  acceptedFormats: string[],
  canBeWithoutFormat?: boolean,
) => {
  const isValid = files.every((file) => {
    // The file name, lowercased: folder names can have dots, and extensions can
    // be uppercase (.DIC).
    const name = file.name.toLowerCase();

    if (canBeWithoutFormat && !name.includes('.')) {
      return true;
    }

    return acceptedFormats.some((format) => name.endsWith(format));
  });

  return isValid;
};
